import React from 'react';
import Load from './Load';
import { Equipe } from '../types/equipe';

interface CategoryInscritosTabProps {
  equipes: Equipe[];
  loading: boolean;
  error?: boolean;
  onAtletaClick?: (atletaId: string) => void;
}

const CategoryInscritosTab: React.FC<CategoryInscritosTabProps> = ({ equipes, loading, error, onAtletaClick }) => {

  if (loading) {
    return <Load />;
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Erro ao carregar inscritos.
      </div>
    );
  }

  if (equipes.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-muted">Nenhuma equipe inscrita</p>
      </div>
    );
  }

  return (
    <div className="row g-3">
      {equipes.map((equipe) => (
        <div key={equipe.id} className="col-12 col-sm-6 col-lg-4">
          <div className="card w-100 shadow-xss rounded-xxl border-0">
            <div className="card-body p-3">
              <h6 className="fw-700 font-xsss text-grey-900 mb-3">{equipe.nome}</h6>
              <div className="d-flex flex-column gap-2">
                {equipe.atletas.map((atleta) => (
                  <div
                    key={atleta.id}
                    className="d-flex align-items-center gap-2 rounded-3 p-2 hover-card"
                    style={{ cursor: 'pointer', marginLeft: -4, marginRight: -4 }}
                    role="button"
                    tabIndex={0}
                    onClick={() => onAtletaClick?.(atleta.id)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onAtletaClick?.(atleta.id);
                      }
                    }}
                  >
                    <img
                      src={atleta.usuario?.imagemUrl || '/assets/images/avatar.jpg'}
                      alt={atleta.usuario?.nome || 'Avatar'}
                      className="rounded-circle"
                      style={{ width: 40, height: 40, objectFit: 'cover', flexShrink: 0 }}
                    />
                    <span className="fw-600 font-xssss text-grey-900 text-truncate">
                      {atleta.usuario?.nome || '\u2014'}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CategoryInscritosTab;
